import React from 'react';

const BlankLoader = props => {
    const { style, imageStyle } = props;
    return (
        <div data-testid="blankLoader" className="col-md-12 col-sm-12 no-padding" style={typeof style !== 'undefined' ? style : { textAlign: 'center', clear: 'both', minHeight: '500px', marginTop: '-100px' }}>
            <img style={typeof imageStyle !== 'undefined' ? imageStyle : { marginTop: '150px' }} src="//static.lenskart.com/media/mobile/images/img-loader.gif" alt="loader" title="loader" />
        </div>
    );
};

export default BlankLoader;
